import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import Logo from "../../icons/logo.svg";

const StyledWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  background-color: white;

  a {
    text-decoration: none;
  }

  .row {
    padding: 2.25rem 0;
  }

  .logo {
    position: relative;
    bottom: 4px;
  }

  nav > * + * {
    margin: 0 0 0 4rem;
  }

  button {
    background-color: var(--orange);
    color: white;
    border: none;
    padding: 0.75em 4.5em;
    border-radius: 50px;
    &:disabled {
      background-color: var(--orange2);
    }
    @media (max-width: 576px) {
      padding: 0.75em 2.5em;
    }
  }

  svg line {
    stroke: var(--orange);
  }

  //---Material UI---
  .MuiPaper-root {
    background-color: transparent;
    color: black;
    border: none;
    box-shadow: unset;
    border-radius: unset !important;
  }

  .MuiAccordion-root::before {
    display: none;
  }

  .MuiAccordionSummary-root {
    padding: 16px 0;
  }

  .MuiAccordionDetails-root {
    padding: 3rem 0;
    justify-content: center;
  }

  .MuiAccordionSummary-content,
  .MuiAccordion-root.Mui-expanded,
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }

  .MuiAccordionSummary-expandIcon.Mui-expanded {
    transform: rotate(135deg);
  }

  @media (max-width: 768px) {
    .logo {
      width: 72px;
      height: 34px;
    }

    nav > * + * {
      margin: 0;
    }
  }
`;

const WEB_APP_URL =
  "https://app.niro.money/see-my-offer/?utm_source=website_nav_bar&utm_medium=organic";

const Header = ({ location }) => {
  const [linkToNav, setLinkToNav] = React.useState(WEB_APP_URL);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const utmMedium = params.get("utm_medium") ?? "organic";
    const utmSource = params.get("utm_source") ?? "website_nav_bar";
    const utmCampaign = params.get("utm_campaign") ?? "";
    const ref = params.get("ref")
      ? `${params.get(
          "ref"
        )}/see-my-offer/?utm_source=${utmSource}&utm_medium=${utmMedium}${
          utmCampaign ? `&utm_campaign=${utmCampaign}` : ""
        }`
      : WEB_APP_URL;
    setLinkToNav(ref);
  }, [location.search]);

  return (
    <>
      <StyledWrapper>
        <div className="container">
          {/* Desktop */}
          <div className="row position-relative d-md-flex align-items-center">
            <div className="col-lg-3 col-2">
              <div
                onClick={() => {
                  window?.scrollTo(0, 0);
                }}
              >
                <Logo className="logo" />
              </div>
            </div>
            <div className="col-lg-9 col-10 d-flex align-items-center justify-content-end">
              <nav className="d-flex align-items-center justify-content-end">
                <Link to="/team" className="d-md-flex d-none">
                  <h6>Team</h6>
                </Link>
                <a href={linkToNav} target="_blank" rel={"noreferrer"}>
                  <button>Claim Offer Now</button>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </StyledWrapper>
    </>
  );
};

export default Header;
